var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRegulativaS = function SvgRegulativaS(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 38,
    viewBox: "0 0 60 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0475 17.3984C27.0475 17.3984 6.88897 28.8978 5.22641 29.9369C3.56385 30.976 4.67222 32.7771 4.67222 32.7771C4.67222 32.7771 5.78059 34.6475 7.51243 33.6084C9.10571 32.5693 28.3637 19.5459 28.3637 19.5459",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7673 23.7716L31.897 21.347C30.0266 18.9225 28.4333 16.2901 27.0478 13.5191L25.6624 10.8175L35.4299 4.72144L37.0924 6.86891C39.1014 9.50129 40.8332 12.2722 42.2879 15.251L43.5349 17.6755L33.7673 23.7716Z",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8658 26.3346L33.0043 26.6117C33.4892 27.4429 34.5976 27.6508 35.3596 27.1659L45.7506 20.6542C46.5819 20.1692 46.7897 19.0609 46.3048 18.2989L46.1663 18.0218C45.6813 17.1905 44.573 16.9827 43.811 17.4676L33.42 23.9793C32.5887 24.4642 32.3809 25.5033 32.8658 26.3346Z",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7523 10.1246L22.8908 10.4017C23.3757 11.233 24.4841 11.4408 25.2461 10.9559L35.6371 4.4442C36.4684 3.95929 36.6762 2.85092 36.1913 2.08891L36.0527 1.81182C35.5678 0.980537 34.4594 0.772717 33.6974 1.25763L23.3064 7.76932C22.4752 8.25423 22.2673 9.29333 22.7523 10.1246Z",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8575 19.3379C29.7492 20.0306 28.2252 19.6842 27.5324 18.5759C26.8397 17.4675 27.1861 15.9435 28.2944 15.2507",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.0718H58.9817",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2018 37.0721H29.5405V35.271C29.5405 34.509 30.164 33.8855 30.926 33.8855H52.8164C53.5784 33.8855 54.2018 34.509 54.2018 35.271V37.0721V37.0721Z",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegulativaS, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/regulativa_s.b41ab3de.svg";
export { ForwardRef as ReactComponent };